var ECarouselRelation;
(function (ECarouselRelation) {
  ECarouselRelation["crossSellLife"] = "crossSellLife";
  ECarouselRelation["crosssell"] = "crosssell";
  ECarouselRelation["upsell"] = "upsell";
  ECarouselRelation["Compatiblesoftware"] = "Compatiblesoftware";
})(ECarouselRelation || (ECarouselRelation = {}));

export { ECarouselRelation as E };
